module.exports = __webpack_public_path__ + "img/sld_connector.ef181cf7.svg";